import request from "../../../utils/request";

export const getCart = '/cart/';

export function modifyCartProduct(param: any) {
    return request.request({
        url: '/cart/',
        method: 'put',
        data: param
    });
}

export function addToCartProducts(param:any){
    return request.post('/cart/addProducts', param);
}
export function deleteCartProduct(ids: Array<number>) {
    return request.post('/cart/delete', ids);
}


export function submitOrder(ids: Array<number>) {
    return request.post('/sales/order/cart', {carts:ids, orderType: '常规订单'});
}

export function submitExchangeOrder(ids:Array<number>){
    return request.post('/sales/order/cart', {carts: ids, orderType: '换货订单'});
}

export function submitConsign(ids: Array<number>) {
    return request.post('/consignment/order/cart', {carts:ids, orderType: '常规订单'});
}
